import {Tooltip} from "react-tooltip";
import {useTranslation} from "react-i18next";
import InstrumentIcon from "../../components/instrument-icon";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import store from "../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../actions/global-actions";
import SvgIcon from "../../components/svg-icon";

const GameFrameButtons = props => {

    const {t} = useTranslation()
    const {onClick, gameType, game, setGameType, favorited, currencies} = props

    const {authenticated} = useSelector(state => state.authenticationReducer)
    const {gameSelectedCurrency} = useSelector(state => state.globalReducer)

    const [search, setSearch] = useState('')
    const [filteredCurrencies, setFilteredCurrencies] = useState([])

    const handleChangeWallet = wall => {
        setSearch('')

        store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency(wall))
    }


    useEffect(() => {
        setFilteredCurrencies(currencies?.filter(
            i => i?.toUpperCase().includes(search?.toUpperCase())))
    }, [currencies, search])

    return (
        <div className="frame__cellar">
            <div className="frame__actions">
                <Tooltip className="tooltip-me" id="rank-tooltip"/>


                <button
                    data-tooltip-id="rank-tooltip"
                    data-tooltip-content={t('game.toggle-fullscreen')}
                    data-tooltip-place="bottom"
                    type="button" onClick={e => onClick('fullscreen')}>
                    <SvgIcon id={'expand'}/>

                </button>


                <Tooltip className="tooltip-me" id="landscape-tooltip"/>

                <button
                    className="frame-theatre"
                    data-tooltip-id="rank-tooltip"
                    data-tooltip-content={t('game.toggle-landscape')}
                    data-tooltip-place="bottom"
                    type="button">
                    <SvgIcon id={'wide'}/>
                </button>




                <Tooltip className="tooltip-me" id="favorite-tooltip"/>
                <button
                    data-tooltip-id="rank-tooltip"
                    data-tooltip-content={t('game.toggle-favorite')}
                    data-tooltip-place="bottom"
                    type="button" onClick={e => onClick('favorite')}>
                    <SvgIcon id={favorited ? 'icon-favourited' : 'non-favorited'}/>
                </button>



            </div>
            <div className="dropdown frame-mob__dropdown">
                <button
                    className="frame-mob__dropdown-btn g-8"
                    type="button"
                    id="frameDrop2"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    <InstrumentIcon code={gameSelectedCurrency}/>
                    {gameSelectedCurrency}
                    <SvgIcon id={'right-down'}/>
                </button>
                <div className="dropdown-menu frame-mob__menu" aria-labelledby="frameDrop2">
                    <div className="frame-mob__search">
                        <input
                            value={search}
                            name="search"
                            onChange={e => setSearch(e.target.value)}
                            placeholder={t('casino.search','Search')}

                            type="text" className="search__input" />
                    </div>
                    <ul className="frame-mob__currencies">

                        {
                            filteredCurrencies?.map(currency => (
                                <li key={currency} onClick={e => handleChangeWallet(currency)}>
                                  <span className="gapp2">
                                      <InstrumentIcon code={currency}/>
                                      {currency}
                                  </span>
                                </li>
                            ))
                        }


                    </ul>
                </div>
            </div>
            <div className="frame__logo"/>
            <div className="frame__switch">

                <input
                    disabled={!authenticated || !game?.has_demo}
                    type="checkbox"
                    className="frame__switch-input"
                    name="switch"
                    id="switch"
                    checked={gameType === 'real'}
                    onChange={e => setGameType(gameType === 'real' ? 'demo' : 'real')}
                />
                <label htmlFor="switch">
                    <span>
                        {t('game.demo-play')}
                    </span>
                    <span>
                        {t('game.real-play')}
                    </span>
                </label>
            </div>
        </div>

    )

}

export default GameFrameButtons
